<template>
  <div class="folders-list search-list">
    <SmartList ref="smart_list_component"
      @smartListItemsSet=onSmartListItemsSet
      :smart_list_items="folders_search_collection.items"
    >
        <template #elements>
            <div class="folder-item"
                v-for='folder in smart_list_items'
                :key="folder.id"
                :class="{'active' : folders_selection_collection.index[folder.id], 'disabled' : folders_disabled[folder.id]}"
            >
              <FolderItemCheck v-if="selection_box"
                :folders_selection_collection="folders_selection_collection"
                :selection_box="selection_box"
                :folder="folder"
                @folderRadioBoxCheck="onFolderCheck"
                @folderCheckBoxCheck="onFolderCheck"
              />

              <FolderItemSearch
                :folders_selection_collection="folders_selection_collection"
                :selection_box="selection_box"
                :list_type="list_type"
                :folder="folder"
                @folderSelect="emit('folderSelect', folder)"
                @folderUnselect="emit('folderUnselect', folder)"
                @folderContextMenu="emit('folderContextMenu', folder)"
              />
            </div>
        </template>
    </SmartList>
  </div>
</template>

<script setup>
  import {ref}                      from 'vue';
  import {defineProps, defineEmits} from 'vue';
  import FolderItemCheck            from './FolderItemCheck.vue';
  import FolderItemSearch           from './FolderItemSearch.vue';
  import SmartList                  from '@/vue/Elements/Tools/SmartList.vue';

  const emit = defineEmits([
    'folderSelect', 'folderUnselect', 'folderContextMenu'
  ])

  const props = defineProps({
    folders_search_collection    : {},
    folders_selection_collection : {},
    folders_collapse_collection  : {},

    folders_disabled : {
      default : {}
    },

    selection_box : {
      default: null,
    },

    list_type : {
      default : 'router'
    }
  })

  const smart_list_items     = ref();
  const smart_list_component = ref();

  const onSmartListItemsSet = (items) => {
    setSmartListItems(items);
  }


  const onFolderCheck = (folder) => {
    if (props.selection_box === 'radio') {
      return onFolderRadioBoxCheck(folder);
    }

    if (props.selection_box === 'check') {
      return onFolderCheckBoxCheck(folder);
    }
  }

  const onFolderRadioBoxCheck = (folder) => {
    if (props.folders_selection_collection.exists(folder.id)) {
      props.folders_selection_collection.delete(folder.id);
      emit('folderUnselect', folder);
      return;
    }

    props.folders_selection_collection.unique(folder);
    emit('folderSelect', folder);
  }

  const onFolderCheckBoxCheck = (folder) => {
    if (props.folders_selection_collection.exists(folder.id)) {
      props.folders_selection_collection.delete(folder.id);
      emit('folderUnselect', folder);
      return;
    }

    props.folders_selection_collection.add(folder);
    emit('folderSelect', folder);
  }

  const setSmartListItems = (items) => {
    smart_list_items.value = items;
  }
</script>